import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'progress-busy',
  templateUrl: './progress-busy.component.html',
  styleUrls: ['./progress-busy.component.scss']
})
export class ProgressBusyComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
